import { AccountIdentifierType, type ReportingLinesUser } from '../types';

const filterAtlassianProfiles = (accountList: ReportingLinesUser[]) => {
	const atlassianUsers = accountList.filter(
		(user) => user.identifierType === AccountIdentifierType.ATLASSIAN_ID,
	);

	return {
		atlassianUsers,
		numMissingProfiles: accountList.length - atlassianUsers.length,
	};
};

export const getUsersForLayoutSections = (
	users: ReportingLinesUser[],
	userCardSlotLimit: number | undefined,
) => {
	const { atlassianUsers, numMissingProfiles } = filterAtlassianProfiles(users);

	if (!userCardSlotLimit) {
		return { usersForCards: atlassianUsers, numMissingProfiles };
	}

	const showAvatarStack =
		atlassianUsers.length + (numMissingProfiles > 0 ? 1 : 0) > userCardSlotLimit;

	const usersForCards = showAvatarStack
		? atlassianUsers.slice(0, userCardSlotLimit - 1)
		: atlassianUsers;

	const usersForAvatarStack = showAvatarStack
		? atlassianUsers.slice(userCardSlotLimit - 1)
		: undefined;

	return { usersForCards, usersForAvatarStack, numMissingProfiles };
};
